/**
 * SVG Responsive image maps.
 *
 * 1) create structure: <div class="svg-image-map"><svg/><img/></div>, recommended 16:9 1280x720 or 1:1 720x720
 * 2) use css: .svg-image-map { position: relative } .svg-image-map svg { position: absolute; }
 * 3) add id="svg-image-map__trigger--[ID]" and style="fill:transparent;" to SVG path, rect, circle trigger elements
 * 4) add class="svg-image-map__target--[ID]" to DOM target elements
 */
jQuery(function($){
    var container = $('.svg-image-map');
    var selectors = 'rect, circle, path, g';
    $(selectors, container).on('mouseenter mouseleave', function(e){
        var target = this.id.split('--')[1];
        if ('mouseenter' == e.type) $('.svg-image-map__target--' + target).removeClass('out').addClass('over');
        else $('.svg-image-map__target--' + target).removeClass('over').addClass('out');
    });
    // add initial state
    $(selectors, container).trigger('mouseleave');
});
